/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      if ( $( '.related' ).length ) {
        $( '.related-slider__slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.related-slider' ).each( function( index, element ) {
          const relatedSlider = new Splide( element, {
            gap: '2rem',
            perPage: 4,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );
          relatedSlider.on( 'overflow', function( isOverflow ) {
            if ( isOverflow ) {
              // Enough slides
            } else {
              relatedSlider.options = {
                arrows: isOverflow,
                drag: isOverflow,
              };
            }
          } );
          relatedSlider.mount( {} );
        } );
      }
      if ( $( '.up-sells' ).length ) {
        $( '.upsell-slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.upsell-slider' ).each( function( index, element ) {
          const upsellSlider = new Splide( element, {
            gap: '2rem',
            perPage: 4,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );
          upsellSlider.on( 'overflow', function( isOverflow ) {
            if ( isOverflow ) {
              // Enough slides
            } else {
              upsellSlider.options = {
                arrows: isOverflow,
                drag: isOverflow,
              };
            }
          } );
          upsellSlider.mount( {} );
        } );
      }
      if ( $( '#splide-gallery' ).length && $( '#splide-gallery__nav' ).length ) {
        const gallery = new Splide( '#splide-gallery', {
          type: 'loop',
          perPage: 1,
          arrows: false,
          pagination: false,
        } );

        const galleryNav = new Splide( '#splide-gallery__nav', {
          type: 'slide',
          perPage: 4,
          arrows: true,
          pagination: false,
          isNavigation: true,
          gap: '12px',
          fixedWidth: '80px',
          direction: 'ttb',
          height: '356px',
          fixedHeight: '80px',
        } );

        galleryNav.on( 'overflow', function( isOverflow ) {
          galleryNav.go( 0 );

          galleryNav.options = {
            arrows: isOverflow,
            drag: isOverflow,
            clones: isOverflow ? undefined : 0,
          };
        } );

        gallery.sync( galleryNav );
        gallery.mount();
        galleryNav.mount();
        // Prevent Woo from replacing your image HTML
        $( document ).on( 'woocommerce_gallery_image_html_updated', function( e ) {
          e.stopImmediatePropagation();
          return false;
        } );

        $( 'form.variations_form' ).on( 'found_variation', function( event, variation ) {
          if ( !variation || !variation.image || !variation.image.src ) return;

          const imageUrl = variation.image.src;
          let slideIndex;

          const navSlides = galleryNav.Components.Slides.get();

          // Check if the slide already exists
          navSlides.forEach( ( slideObj, index ) => {
            const img = slideObj.slide.querySelector( 'img' );
            if ( img && img.src === imageUrl ) {
              slideIndex = index;
            }
          } );

          // If not present, append new slide to both sliders
          if ( typeof slideIndex === 'undefined' ) {
            const navSlide = document.createElement( 'li' );
            navSlide.className = 'splide__slide';
            navSlide.innerHTML = `<div class="fit-image"><img src="${imageUrl}" class="object-cover"></div>`;
            galleryNav.add( navSlide );

            const mainSlide = document.createElement( 'li' );
            mainSlide.className = 'splide__slide';
            mainSlide.innerHTML = `<div class="fit-image"><img src="${imageUrl}" class="object-contain"></div>`;
            gallery.add( mainSlide );

            galleryNav.refresh();
            gallery.refresh();

            slideIndex = gallery.length - 1;
          }

          const galleryLoopIndex = gallery.Components.Controller.toIndex( slideIndex );
          gallery.go( galleryLoopIndex );
          galleryNav.go( slideIndex );
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'woocommerce-related', COMPONENT );
} )( app );
